import styled from "styled-components";

export const Portait1Style = styled.div`
  width:100%;
  height:100%;
  .img-fluid {
    display: block;
    max-width: 100%;
  }

  .container4 {
    width:100%;
    height:100%;
    overflow: hidden;
  }

  .f-peach {
    color: #f98365;
  }

  .f-white {
    color: #fff;
  }

  .f-blue {
    color: #005596;
  }

  .back-layer {
    width:100%;
    height:100%;
    position: absolute;

    background-size: cover;
  }

  .text-wrapper {
    top: 0;
    position: absolute;
    width:100%;
    height:100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding:5%;
  }

  .text-wrapper > div {
    width: 100%;
  }
`;
